import { jwtDecode } from "jwt-decode";

const getStorage = (rememberMe: boolean) => (rememberMe ? localStorage : sessionStorage);
export const getSetting = <T>(key: string, defaultValue: T) => {
	const localStorageValue = localStorage.getItem(key);
	const sessionStorageValue = sessionStorage.getItem(key);
	// TODO: try to read it from cookie
	return localStorageValue || sessionStorageValue || defaultValue;
};
export const saveSetting = (key: string, value: string | boolean | null, rememberMe = false) => {
	const storage = getStorage(rememberMe);
	if (value === null) {
		storage.removeItem(key);
		return;
	}
	storage.setItem(key, `${value}`);
};

interface IUserScopeToken {
	nameid?: string;
	Email?: string;
}

const hashScope = (value: string): string => {
	let hash = 5381;
	for (let i = 0; i < value.length; i++) hash = ((hash << 5) + hash + value.charCodeAt(i)) >>> 0;
	return hash.toString(36);
};

const readUserScope = (): string => {
	const token = getSetting("token", "");
	if (!token) return "";

	try {
		const decoded = jwtDecode<IUserScopeToken>(token);
		if (decoded?.nameid) return decoded.nameid;
		return decoded?.Email ? hashScope(decoded.Email) : "";
	} catch {
		return "";
	}
};

let userScope = readUserScope();

export const refreshUserScope = () => {
	userScope = readUserScope();
};

export const getUserScopedKey = (key: string) => (userScope ? `u:${userScope}:${key}` : key);

const readRawSetting = (key: string): string | null => localStorage.getItem(key) ?? sessionStorage.getItem(key);

export const getUserSetting = <T>(key: string, defaultValue: T) => {
	const scopedKey = getUserScopedKey(key);
	const scoped = readRawSetting(scopedKey);
	if (scoped !== null) return scoped;

	if (scopedKey === key) return defaultValue;

	const legacy = readRawSetting(key);
	if (legacy === null) return defaultValue;

	saveSetting(scopedKey, legacy, true);
	return legacy;
};

export const saveUserSetting = (key: string, value: string | boolean | null, rememberMe = true) =>
	saveSetting(getUserScopedKey(key), value, rememberMe);

export const migrateLegacyPrefixedKeys = (prefix: string) => {
	const scopedPrefix = getUserScopedKey(prefix);
	if (scopedPrefix === prefix) return;

	Object.keys(localStorage)
		.filter((key) => key.startsWith(prefix) && !key.startsWith("u:"))
		.forEach((legacyKey) => {
			const scopedKey = getUserScopedKey(legacyKey);
			if (localStorage.getItem(scopedKey) !== null) return;

			const value = localStorage.getItem(legacyKey);
			if (value !== null) localStorage.setItem(scopedKey, value);
		});
};
